module.exports = __webpack_public_path__ + "static/img/16.8ad6caba.jpg";